import React from "react";
import CareerSkillsSection from "../Shared/CareerSkillsSection";

const BusinessAdministrationCareerSkills = () => {
  return (
    <CareerSkillsSection
      title="BUSINESS ADMINISTRATION SKILLS? CHECK."
      paragraphs={[
        `In Business Administration at JRIIT, you'll get an education built on core programs that are vital for success in today's business world — expertise in management, marketing, finance, and organizational leadership. These are the skills that employers say make JRIIT Business Administration graduates stand out. Our Business Administration program offers both a 1-year Certificate for foundational skills and a 2-year Diploma for advanced specialization in business management.`,

        `Why? We emphasize hands-on learning instead of traditional letter grades. In every course, you'll receive detailed feedback on your business strengths and where you can improve, giving you a more complete picture of your growth.`,

        `Discover our Business Administration programs below and unlock the skills to shape your future.`,
      ]}
    />
  );
};

export default BusinessAdministrationCareerSkills;
